module.exports = __webpack_public_path__ + "img/checked_on.3f7a2bb8.svg";